import { render } from "./AccessDeniedComponent.vue?vue&type=template&id=bfb2a046&ts=true"
import script from "./AccessDeniedComponent.vue?vue&type=script&lang=ts"
export * from "./AccessDeniedComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__